import { useNewRelic } from '@/composables/useNewRelic';
import { defineStore, getActivePinia } from 'pinia';

export const resetAllStores = () => {
  const activepinia = getActivePinia();
  const newRelic = useNewRelic();

  try {
    if (activepinia) {
      Object.entries(activepinia.state.value).forEach(([storeName, state]) => {
        const storeDefinition = defineStore(storeName, state);
        const store = storeDefinition(activepinia);

        store.$reset();
      });
    }
  } catch (error) {
    newRelic.noticeError(error as Error, { context: { functionName: 'resetAllStores' } });
  }

  // ToDo ideally all info should be on stores so no need for this, but not the case at the time
  localStorage.clear();
  sessionStorage.clear();
};
